import { BaseDto } from 'src/dtos/common/baseDto';

/** tqc_gauge_calib (계측기 검교정 내역) */
export interface TqcGaugeCalibDto extends BaseDto {
	equipmentCd: string;   // 계측기코드 (PK)
	compCd: string;        // 사업장 (PK)
	calibDt: string;       // 검교정일자 (PK)
	empNo: string;         // 담당자
	passYn: string;        // 합격여부
	nextCalibDt: string;   // 차기검교정일자
	resultFileId: string;  // 검교정결과서 파일ID
	remark: string;        // 비고

	inserted?: boolean;
	isModified?: boolean;
}

export const defaultTqcGaugeCalibDto: TqcGaugeCalibDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	equipmentCd: '',
	compCd: '',
	calibDt: '',
	empNo: '',
	passYn: 'Y',
	nextCalibDt: '',
	resultFileId: '',
	remark: '',

	inserted: false,
	isModified: false,
};
